import React from 'react';

class TimerText extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      timerOffset   : this.props.defaultData!==undefined&&this.props.defaultData[this.props.stateName]!==undefined?this.props.defaultData[this.props.stateName]:0,
      timerIsActive : this.props.defaultData!==undefined&&this.props.defaultData[this.props.stateName+'_isactive']!==undefined?this.props.defaultData[this.props.stateName+'_isactive']:false,
      countdown : this.props.defaultData!==undefined&&this.props.defaultData[this.props.stateName+'_countdown']!==undefined?this.props.defaultData[this.props.stateName+'_countdown']:false,
      startAt: Date.now(),
      currentMin:0,
      currentSec:0,
    };
  }

  onSetTimeout() {
    console.log(this.props.stateName+" onSetTimeout");
  }

  onInit (overlayConfig) {
  }

  tick() {

    var m = this.state.currentMin;
    var s = this.state.currentSec;

    var second = this.getSecond();
    const o = this.props.overlayConf;

    if(second > o.timerMax) {
      second = o.timerMax;
    } else if(second < o.timerMin ) {
      second = o.timerMin;
    }
    second = second + o.timerOffset;

  //    console.log("second",second);
    var minF = (parseInt(second)/1000) / 60 ;
    var minI = Math.floor(minF) ;
    var sec = Math.floor((minF-minI)*60);

    if(s!==sec || m!==minI) {
      this.setState({currentSec:sec,currentMin:minI});
    }
  }

  onData (data,key) {
    if ( key !== undefined ) {
        if ( key === this.props.stateName ) {

            if(data.active !== undefined){
              if( data.active === "true" ||  data.active === true ) {
                this.setState({timerOffset:parseInt(data.offset,10),startAt:Date.now(),timerIsActive: (data.active==="true"),countdown: (data.countdown === true || data.countdown === "true")},()=>{
                    this.startTimer();
                });
              } else {
              //  console.log("######## TIMER STOP:", key,data);
                this.setState({timerIsActive: false},()=>{
                    this.stopTimer();
                });
              }
            } else {
              this.setState({ timerOffset:parseInt(data.offset,10), startAt:Date.now()},()=>{
                 this.tick();
              });
            }

        }
    }
  }

  getSecond() {

    if(!this.state.timerIsActive) {
      return this.state.timerOffset;
    }

    var offset =  this.state.timerOffset;
    var startAt = this.state.startAt;
    var result = 0;
    result = Date.now() - startAt;
    if(this.state.countdown) {
      result = offset - result;
    } else {
      result = result + offset;
    }
    if(result < 0) {
        result = 0;
    }
    return result;
  }

  startTimer() {
    if(this.interval !== undefined ) {
      this.stopTimer();
    }
    this.setState({startAt:Date.now()},()=>{
      this.interval = setInterval(() => this.tick(), (50));
    });
  }

  stopTimer() {
    clearInterval(this.interval);

  }

  componentDidMount() {
    this.props.display.registDataListener(this.props.stateName,this);
    this.props.overlay.registDataListener(this.props.overlayConf.title ,this);

    if(this.props.readAlong !== undefined) {
      var readAlongs = this.props.readAlong.split("|");
      for (var r in readAlongs){
          this.props.display.registDataListener(readAlongs[r],this);
      }
    }

    if(this.props.display.state.gameStates[this.props.stateName]!==undefined) {
      this.onData(this.props.display.state.gameStates[this.props.stateName],this.props.stateName);
    }
    if(this.state.timerIsActive === true) {
      this.startTimer();
    }
  }


  render() {
      var offset = this.getSecond();
      const o = this.props.overlayConf;

      if(offset >= o.timerDisplayFrom && offset <= o.timerDisplayUntil) {

          var formatMin = parseInt(this.state.currentMin)>99?('000'+this.state.currentMin).slice(-3):('00'+this.state.currentMin).slice(-2);
          var formatSec = ('00'+this.state.currentSec).slice(-2);


          var tmp = o.displayRule;
          if ( tmp !== undefined && tmp !== "" ) {

            var formatMinShort = this.state.currentMin;
            var formatSecShort = this.state.currentSec;
            tmp = tmp.replace("S",formatSec).replace("s",formatSecShort).replace("M",formatMin).replace("m",formatMinShort);
            return tmp;
          }

          return formatMin + ":" + formatSec;

      } else {
        return "";
      }
  }
}
export default TimerText;
